import request from '@/api/request'

export default {
  getAsset (payload) {
    const url = `/asset/get?assetId=${payload.assetId}`
    return request({ method: 'GET', url })
  },
  getAssets (payload) {
    const limit = payload.limit ? payload.limit : 21
    const offset = payload.offset ? payload.offset : 0
    const width = payload.w ? payload.w : 0
    const height = payload.h ? payload.h : 0
    const country = (payload.country && payload.country.value) ? payload.country.value : ''
    const city = (payload.city && payload.city.value) ? payload.city.value : ''
    const parent = city || country
    const search = payload.search ? payload.search : ''
    const timestamp = +new Date()
    const params = `limit=${limit}&offset=${offset}&w=${width}&h=${height}&parent=${parent}&search=${search}&time=${timestamp}`
    const url = `/asset/get?${params}`
    return request({ method: 'GET', url })
  },
  uploadAsset (payload) {
    const url = `/asset`
    const data = payload
    return request({ method: 'POST', url, data })
  }
}
